import { ProfileEditDto } from '@diritto/common/account/dtos/profile-edit.dto';
import { ProfileImageResponseDto } from '@diritto/common/account/dtos/profile-image.response.dto';
import { ProfileSettingRequestDto } from '@diritto/common/account/dtos/profile-setting.dto';
import { ProfileResponseDto } from '@diritto/common/account/dtos/profile.response.dto';
import { ProfilesResponseDto } from '@diritto/common/account/dtos/profiles.response.dto';
import { ValidateProfileNicknameDto } from '@diritto/common/account/dtos/validate-profile-nickname.dto';
import { ResponseDto } from '@diritto/common/base/response.dto';
import { Http } from '@diritto/common/utils/requester/http';
import { AxiosRequestConfig } from 'axios';

export class ProfileApi {
  constructor(
    protected url: string,
    protected http: Http,
  ) {}

  async findProfileById(profileId: number, options?: AxiosRequestConfig) {
    const res = await this.http.get<ProfileResponseDto>(`${this.url}/accounts/profiles/${profileId}`, options);
    return res.data;
  }

  async validateNickname(nickname: string) {
    const res = await this.http.post<ValidateProfileNicknameDto, ResponseDto>(
      `${this.url}/accounts/profiles/validation/nickname`,
      { nickname },
    );
    return res.data;
  }

  async getMyProfiles() {
    const res = await this.http.get<ProfilesResponseDto>(`${this.url}/accounts/profiles/me`);
    return res.data;
  }

  async createProfile(params: ProfileEditDto) {
    const res = await this.http.post<ProfileEditDto, ProfileResponseDto>(`${this.url}/accounts/profiles/me`, params);
    return res.data;
  }

  async updateProfile(params: ProfileEditDto, id: number) {
    const res = await this.http.patch<ProfileEditDto, ProfileResponseDto>(
      `${this.url}/accounts/profiles/me/${id}`,
      params,
    );
    return res.data;
  }

  async uploadProfileImage(data: FormData): Promise<ProfileImageResponseDto> {
    const res = await this.http.post<FormData, ProfileImageResponseDto>(
      `${this.url}/accounts/profiles/me/images`,
      data,
    );
    return res.data;
  }

  async deleteProfileImage(id: number) {
    const res = await this.http.delete<ResponseDto>(`${this.url}/accounts/profiles/me/images/${id}`);
    return res.data;
  }

  async addProfileSetting(data: ProfileSettingRequestDto) {
    const res = await this.http.post<ProfileSettingRequestDto, ResponseDto>(
      `${this.url}/accounts/profiles/me/setting`,
      data,
    );
    return res.data;
  }

  async updateProfileSetting(data: ProfileSettingRequestDto) {
    const res = await this.http.put<ProfileSettingRequestDto, ResponseDto>(
      `${this.url}/accounts/profiles/me/setting`,
      data,
    );
    return res.data;
  }
}
